import { useTranslation } from 'react-i18next';
import { ContainerEconomyModeBar, IconButton } from '../styles';
import { EconomyModeBarProps } from '../types';
import { ReactElement, useCallback, useState } from 'react';
import { EnergySavingIcon, InfoIconCR } from '~/icons';
import { ToggleSwitchMini } from '~/components/ToggleSwitch';
import { ModalEconomyModeInfo } from '~/components/ModalsRemoteControl/EconomyModeInfo';
import Skeleton from 'react-loading-skeleton';
import { ModalEconomyModeOff } from '../../../../components/ModalsRemoteControl/EconomyModeOff';

export function EconomyModeBar({
  checked,
  loading,
  onClickCheck,
  openEconomyModeOffModalByManualMode,
  onCloseEconomyModeOff,
}: Readonly<EconomyModeBarProps>): ReactElement {
  const { t } = useTranslation();
  const [openModalInfo, setOpenModalInfo] = useState(false);
  const [openModalConfirm, setOpenModalConfirm] = useState(false);

  const onCloseModalInfo = useCallback((): void => {
    setOpenModalInfo(false);
  }, []);

  const onOpenModalInfo = useCallback((): void => {
    setOpenModalInfo(true);
  }, []);

  const onCloseModalConfirm = useCallback((): void => {
    setOpenModalConfirm(false);
    onCloseEconomyModeOff();
  }, []);

  const onConfirmModal = useCallback((): void => {
    onCloseModalConfirm();
    onClickCheck();
  }, [onClickCheck, onCloseModalConfirm]);

  function onClickToggle(): void {
    if (checked) {
      setOpenModalConfirm(true);
      return;
    }

    onClickCheck();
  }

  if (loading) {
    return (
      <ContainerEconomyModeBar>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <Skeleton width="24px" height="24px" circle />
          <Skeleton width="124px" height="20px" borderRadius={8} />
          <Skeleton width="16px" height="16px" circle />
        </div>
        <div style={{ marginLeft: 'auto' }}>
          <Skeleton width="40px" height="20px" borderRadius={12} />
        </div>
      </ContainerEconomyModeBar>
    );
  }

  return (
    <>
      <ModalEconomyModeOff
        isOpen={openModalConfirm || openEconomyModeOffModalByManualMode}
        onClose={onCloseModalConfirm}
        actionButton1={onConfirmModal}
      />
      <ModalEconomyModeInfo
        isOpen={openModalInfo}
        onClose={onCloseModalInfo}
      />
      <ContainerEconomyModeBar>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
          <EnergySavingIcon />
          <h2 style={{ margin: 0 }}>{t('modoEconomia')}</h2>
        </div>
        <IconButton
          type="button"
          onClick={onOpenModalInfo}
          data-testid="button-economy-info"
        >
          <InfoIconCR />
        </IconButton>
        <ToggleSwitchMini
          checked={checked}
          onClick={onClickToggle}
          style={{ marginLeft: 'auto', padding: '10px 0', height: '100%' }}
          variant="remote-control"
          altText="economy-mode-toggle"
        />
      </ContainerEconomyModeBar>
    </>
  );
}
